<template>
  <div class="feed-status">
    <p v-if="error" role="status">{{ error }} <SaltButton style-type="plain" :disabled="loading" @click="$emit('retry')">重试</SaltButton></p>
    <p v-else-if="loading" role="status">正在加载…</p>
    <p v-else-if="!count" role="status">{{ emptyText }}</p>
    <SaltButton v-if="more && !error" class="load-more" style-type="subtle" :disabled="loading" @click="$emit('more')">{{ loading ? '正在加载…' : '加载更多' }}</SaltButton>
  </div>
</template>
<script>
import SaltButton from '../ui/SaltButton.vue';
export default { name: 'FeedStatus', components: { SaltButton }, props: { error: { type: String, default: '' }, loading: Boolean, count: { type: Number, default: 0 }, more: Boolean, emptyText: { type: String, default: '来源暂未返回此分类内容。' } } };
</script>
<style scoped>
.feed-status { color: var(--salt-subtext, var(--color-secondary)); font-size: 14px; text-align: center; }
p { margin: 20px 0; line-height: 1.7; }
.load-more { margin: 20px 0; }
button:focus:not(:focus-visible) { outline: none; }
</style>
